import { ReactComponent as ISOLogoIcon } from "../../assets/isotipo.svg";
import bgLogin from "../../assets/bgLogin.jpg";
import { useNavigate } from "react-router-dom";
import { ForgotCredentialsForm } from "./forgot-credentials-form";
import { useState } from "react";
import { Button } from "../../components/button";
import { CreateHelpDeskTicket } from "../../types/help_desk_tickets.types";
import { CheckCircle2 } from "lucide-react";

const ForgotCredentials = () => {
  const [isSubmissionSuccessful, setIsSubmissionSuccessful] = useState(false);
  const navigate = useNavigate();

  const handleSubmitSuccess = (ticketData: CreateHelpDeskTicket) => {
    setIsSubmissionSuccessful(true);
  };

  return (
    <div
      className="flex min-h-screen items-center justify-center bg-cover bg-center relative bg-fixed overflow-hidden"
      style={{ backgroundImage: `url(${bgLogin})` }}
    >
      <div className="absolute inset-0 bg-black opacity-50 z-0" />

      <div className="relative w-full max-w-md p-8 bg-[#F8F9FA] shadow-xl rounded-2xl bg-opacity-80 text-gray-900 border border-gray-300 z-10">
        {isSubmissionSuccessful ? (
          <div className="text-center space-y-4 flex flex-col items-center">
            <CheckCircle2 className="w-10 h-10 text-green-600" />
            <h2 className="text-2xl font-bold text-green-600">
              ¡Solicitud enviada!
            </h2>
            <p>
              Recibimos tu solicitud para recuperar el acceso a tu cuenta. Un
              administrador va a revisar el caso y se va a contactar con vos a
              la brevedad.
            </p>
            <p className="text-gray-600">
              Te vamos a contactar al número de teléfono que nos proporcionaste.
            </p>

            <Button
              type="button"
              text="Volver al Inicio de Sesión"
              variant="auth"
              onClick={() => navigate("/login")}
            />
          </div>
        ) : (
          <>
            <div className="flex items-center mb-6">
              <h2 className="text-2xl font-semibold text-center flex-1">
                {isSubmissionSuccessful
                  ? "Solicitud Enviada"
                  : "Recuperar Acceso"}
              </h2>
            </div>
            <p className="text-sm text-gray-600 mb-6">
              Por favor, completa el formulario con tus datos personales para
              verificar tu identidad. Un administrador revisará tu solicitud y
              se pondrá en contacto lo antes posible.
            </p>

            <ForgotCredentialsForm onSubmitSuccess={handleSubmitSuccess} />
          </>
        )}

        <div className="mt-6 flex items-center justify-center gap-2 text-gray-600 text-xs">
          <span>Powered by</span>
          <ISOLogoIcon className="w-8" />
          
            Hiva
        
        </div>
      </div>
    </div>
  );
};

export default ForgotCredentials;
